export const Organizations = {
    neer: {
        id: '5097037e-c102-4325-ac9f-b6bded20ce5a',
    },
} as const;
